"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UltimateSubmissionPolicy = exports.NewProjectData = exports.Project = void 0;
var expected_student_file_1 = require("./expected_student_file");
var http_client_1 = require("./http_client");
var instructor_file_1 = require("./instructor_file");
var utils_1 = require("./utils");
var ProjectCoreData = /** @class */ (function () {
    function ProjectCoreData(args) {
        this.pk = args.pk;
        this.name = args.name;
        this.last_modified = args.last_modified;
        this.course = args.course;
        this.visible_to_students = args.visible_to_students;
        this.closing_time = args.closing_time;
        this.soft_closing_time = args.soft_closing_time;
        this.timezone = args.timezone;
        this.disallow_student_submissions = args.disallow_student_submissions;
        this.disallow_group_registration = args.disallow_group_registration;
        this.guests_can_submit = args.guests_can_submit;
        this.min_group_size = args.min_group_size;
        this.max_group_size = args.max_group_size;
        this.submission_limit_per_day = args.submission_limit_per_day;
        this.allow_submissions_past_limit = args.allow_submissions_past_limit;
        this.groups_combine_daily_submissions = args.groups_combine_daily_submissions;
        this.submission_limit_reset_time = args.submission_limit_reset_time;
        this.num_bonus_submissions = args.num_bonus_submissions;
        this.total_submission_limit = args.total_submission_limit;
        this.allow_late_days = args.allow_late_days;
        this.ultimate_submission_policy = args.ultimate_submission_policy;
        this.hide_ultimate_submission_fdbk = args.hide_ultimate_submission_fdbk;
        this.has_handgrading_rubric = args.has_handgrading_rubric;
        this.send_email_on_submission_received = args.send_email_on_submission_received;
        this.send_email_on_non_deferred_tests_finished
            = args.send_email_on_non_deferred_tests_finished;
        this.use_honor_pledge = args.use_honor_pledge;
        this.honor_pledge_text = args.honor_pledge_text;
    }
    return ProjectCoreData;
}());
var Project = /** @class */ (function (_super) {
    __extends(Project, _super);
    function Project(args) {
        var _this = _super.call(this, args) || this;
        if (args.instructor_files !== undefined) {
            _this.instructor_files = args.instructor_files.map(function (item) { return new instructor_file_1.InstructorFile(item); });
        }
        _this.expected_student_files = args.expected_student_files.map(function (item) { return new expected_student_file_1.ExpectedStudentFile(item); });
        return _this;
    }
    Project.subscribe = function (observer) {
        Project._subscribers.add(observer);
    };
    Project.unsubscribe = function (observer) {
        Project._subscribers.delete(observer);
    };
    Project.create = function (course_pk, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/courses/" + course_pk + "/projects/", data)];
                    case 1:
                        response = _a.sent();
                        result = new Project(response.data);
                        Project.notify_project_created(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Project.notify_project_created = function (project) {
        var e_1, _a;
        try {
            for (var _b = __values(Project._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_project_created(project);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Project.get_by_pk = function (pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/projects/" + pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new Project(response.data)];
                }
            });
        });
    };
    Project.get_all_from_course = function (course_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response, projects;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/courses/" + course_pk + "/projects/")];
                    case 1:
                        response = _a.sent();
                        projects = response.data.map(function (project_data) { return new Project(project_data); });
                        utils_1.sort_by_name(projects);
                        return [2 /*return*/, projects];
                }
            });
        });
    };
    Project.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/projects/" + this.pk + "/", utils_1.filter_keys(this, Project.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, new Project(response.data));
                        Project.notify_project_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    Project.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var last_modified, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        last_modified = this.last_modified;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/projects/" + this.pk + "/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, new Project(response.data));
                        if (last_modified !== this.last_modified) {
                            Project.notify_project_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Project.prototype.delete = function () {
        return http_client_1.HttpClient.get_instance().delete("/projects/" + this.pk + "/");
    };
    Project.notify_project_changed = function (project) {
        var e_2, _a;
        try {
            for (var _b = __values(Project._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_project_changed(project);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Project.prototype.num_queued_submissions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/projects/" + this.pk + "/num_queued_submissions/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    Project.prototype.copy_to_course = function (course_pk, new_name) {
        return __awaiter(this, void 0, void 0, function () {
            var response, new_project;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/projects/" + this.pk + "/copy_to_course/" + course_pk + "/", { new_project_name: new_name })];
                    case 1:
                        response = _a.sent();
                        new_project = new Project(response.data);
                        Project.notify_project_created(new_project);
                        return [2 /*return*/, new_project];
                }
            });
        });
    };
    Project._subscribers = new Set();
    Project.EDITABLE_FIELDS = [
        'name',
        'visible_to_students',
        'closing_time',
        'soft_closing_time',
        'timezone',
        'disallow_student_submissions',
        'disallow_group_registration',
        'guests_can_submit',
        'min_group_size',
        'max_group_size',
        'submission_limit_per_day',
        'allow_submissions_past_limit',
        'groups_combine_daily_submissions',
        'submission_limit_reset_time',
        'num_bonus_submissions',
        'total_submission_limit',
        'allow_late_days',
        'ultimate_submission_policy',
        'hide_ultimate_submission_fdbk',
        'send_email_on_submission_received',
        'send_email_on_non_deferred_tests_finished',
        'use_honor_pledge',
        'honor_pledge_text',
    ];
    return Project;
}(ProjectCoreData));
exports.Project = Project;
var NewProjectData = /** @class */ (function () {
    function NewProjectData(args) {
        this.name = args.name;
        this.visible_to_students = args.visible_to_students;
        this.closing_time = args.closing_time;
        this.soft_closing_time = args.soft_closing_time;
        this.timezone = args.timezone;
        this.disallow_student_submissions = args.disallow_student_submissions;
        this.disallow_group_registration = args.disallow_group_registration;
        this.guests_can_submit = args.guests_can_submit;
        this.min_group_size = args.min_group_size;
        this.max_group_size = args.max_group_size;
        this.submission_limit_per_day = args.submission_limit_per_day;
        this.allow_submissions_past_limit = args.allow_submissions_past_limit;
        this.groups_combine_daily_submissions = args.groups_combine_daily_submissions;
        this.submission_limit_reset_time = args.submission_limit_reset_time;
        this.num_bonus_submissions = args.num_bonus_submissions;
        this.total_submission_limit = args.total_submission_limit;
        this.allow_late_days = args.allow_late_days;
        this.ultimate_submission_policy = args.ultimate_submission_policy;
        this.hide_ultimate_submission_fdbk = args.hide_ultimate_submission_fdbk;
        this.send_email_on_submission_received = args.send_email_on_submission_received;
        this.send_email_on_non_deferred_tests_finished
            = args.send_email_on_non_deferred_tests_finished;
        this.use_honor_pledge = args.use_honor_pledge;
        this.honor_pledge_text = args.honor_pledge_text;
    }
    return NewProjectData;
}());
exports.NewProjectData = NewProjectData;
// This class contains options for choosing which submissions are
// used for final grading. AG test cases also have a feedback
// option that will only be used for ultimate submissions.
var UltimateSubmissionPolicy;
(function (UltimateSubmissionPolicy) {
    // The submission that was made most recently
    UltimateSubmissionPolicy["most_recent"] = "most_recent";
    // The submission with the highest score, using "normal"
    // feedback settings to compute scores.
    UltimateSubmissionPolicy["best_with_normal_fdbk"] = "best_basic_score";
    // The submission with the highest score. The score used
    // for comparison is computed using maximum feedback
    // settings.
    UltimateSubmissionPolicy["best"] = "best";
})(UltimateSubmissionPolicy = exports.UltimateSubmissionPolicy || (exports.UltimateSubmissionPolicy = {}));
//# sourceMappingURL=project.js.map